<template>
  <!-- header -->
  <div>
    <el-top-nav-menu-4
      companyTitle="分包商注册"
      :dashboard="shopPage"
      :showInput="showInput"
      :Menu4Href="Menu4Href"
      ref="topNavMenu"
      width="1180px"
      padding="0"
      :logo="LOGO"
    >
    </el-top-nav-menu-4>
    <!-- openStep -->
    <div class="openStep">
      <div class="one">
        <div class="circle check_circle">
          <div class="circle1">1</div>
        </div>
        <span :class="check_page >= 0 ? ' check_stepTxt' : 'stepTxt'"
          >准备资料</span
        >
      </div>
      <span class="circleSmall circleSmall1"></span>
      <span class="circleSmall circleSmall2"></span>
      <span class="circleSmall circleSmall3"></span>
      <div class="two">
        <div :class="check_page >= 1 ? 'circle check_circle' : 'circle'">
          <div class="circle1">2</div>
        </div>
        <span :class="check_page >= 1 ? ' check_stepTxt' : 'stepTxt'"
          >快速注册</span
        >
      </div>
      <span class="circleSmall circleSmall1"></span>
      <span class="circleSmall circleSmall2"></span>
      <span class="circleSmall circleSmall3"></span>
      <div class="three">
        <div :class="check_page >= 2 ? 'circle check_circle' : 'circle'">
          <div class="circle1">3</div>
        </div>
        <span :class="check_page >= 2 ? ' check_stepTxt' : 'stepTxt'"
          >完善信息</span
        >
      </div>
      <span class="circleSmall circleSmall1"></span>
      <span class="circleSmall circleSmall2"></span>
      <span class="circleSmall circleSmall3"></span>
      <div class="four">
        <div :class="check_page >= 3 ? 'circle check_circle' : 'circle'">
          <div class="circle1">4</div>
        </div>
        <span :class="check_page >= 3 ? ' check_stepTxt' : 'stepTxt'"
          >申请合作</span
        >
      </div>
      <span class="circleSmall circleSmall1"></span>
      <span class="circleSmall circleSmall2"></span>
      <span class="circleSmall circleSmall3"></span>
      <div class="five">
        <div :class="check_page >= 4 ? 'circle check_circle' : 'circle'">
          <div class="circle1">5</div>
        </div>
        <span :class="check_page >= 4 ? ' check_stepTxt' : 'stepTxt'"
          >审批</span
        >
      </div>
    </div>
    <div v-if="check_page == 0">
      <!-- content -->
      <div class="content">
        未设计
        <el-button
          class="right-btn btn"
          size="mini"
          type="primary-icon-medium"
          @click="next()"
        >
          <span>下一步</span>
        </el-button>
      </div>
    </div>
    <div v-if="check_page == 1">
      <SubFastRegCode
        :flag="flag"
        @nextPerfect="nextPerfect"
        @toFlag="toFlag"
      ></SubFastRegCode>
    </div>
    <div v-show="check_page == 2">
      <SubPerfectInfo
        :companyMessage="companyMessage"
        @nextPerfectInfo="nextPerfectInfo"
        @PreviousInfo="previousInfo"
      ></SubPerfectInfo>
    </div>
    <div v-show="check_page == 3">
      <SubCooperation @next="next" @Previous="previous"></SubCooperation>
    </div>
    <div v-show="check_page == 4">
      <subApproval></subApproval>
    </div>
    <el-dialog
      class="dialog-center"
      title="提示"
      :visible.sync="dialogVisible2"
      :show-close="false"
      width="300px"
      show-divider
      show-shadow
      custom-class="el-dialog--customize"
    >
      <span>网络请求超时，请稍后再试</span>
      <span slot="footer" style="text-align: center">
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="closeModalTimeout"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SubFastRegCode from "./subFastReg/code";
import SubPerfectInfo from "./subPerfectInfo/index";
import SubCooperation from "./subCooperation/index";
import subApproval from "./subApproval";
import LOGO from "../../../assets/images/logoS.png";
import { getCompany, getUserInfo } from "@/api/register";
export default {
  data() {
    return {
      shopPage: this.$addUrlPerFix(process.env.VUE_APP_SHOPPAGE_URL),
      Menu4Href: true,
      LOGO: LOGO,
      showInput: false,
      leaves: "",
      check_page: 0,
      companyMessage: null,
      flag: false,
      last: {},
      local: {},
    };
  },
  components: {
    SubFastRegCode,
    SubCooperation,
    SubPerfectInfo,
    subApproval,
  },
  created() {},
  computed: {
    dialogVisible2() {
      return this.$store.state.app.isShowDialogTimeout;
    },
  },
  mounted() {
    if (sessionStorage.getItem("local")) {
      this.last = JSON.parse(sessionStorage.getItem("local"));
      sessionStorage.removeItem("local");
      this.check_page = this.last.check_page;
      this.$eventBus.$emit("last", this.last);
      this.$eventBus.$emit("querySupplierCode", this.last.supplierCode);
    }
    this.$eventBus.$on("localSub", (res) => {
      console.log(res, "接受参数");
      this.last = res;
      this.check_page = this.last.check_page;
      this.$eventBus.$emit("last", this.last);
      this.$eventBus.$emit("querySupplierCode", this.last.supplierCode);
    });

    this.$eventBus.$on("leaves", (res) => {
      this.leaves = res;
      this.check_page = 2;
      this.$eventBus.$emit("querySupplierCode", this.leaves);
    });
  },
  // beforeDestroy() {
  //   this.$eventBus.$off("localSub");
  //   this.$eventBus.$off("leaves");
  // },

  methods: {
    closeModalTimeout() {
      this.$store.commit("SET_IS_SHOW_DIALOG_TIMEOUT", false);
    },
    next() {
      this.check_page++;
    },
    nextPerfect({ name }) {
      this.check_page++;
    },
    toFlag() {
      this.flag = false;
    },
    nextPerfectInfo() {
      this.check_page++;
    },
    previousInfo() {
      this.check_page--;
      this.flag = true;
    },
    previous() {
      this.check_page--;
    },
  },
};
</script>

<style lang="scss" scoped>
> html,
body {
  font-family: Arial;
  background-color: #f5f5f9;
  padding: 0px;
  margin: 0px;
  -webkit-font-smoothing: antialiased; /*让字体更润滑*/
  -moz-osx-font-smoothing: grayscale; /*让字体更润滑*/
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*禁止链接高亮*/
  -webkit-touch-callout: none; /*禁止链接长按弹出选项*/
  height: 100%;
}
ul,
li {
  margin: 0px;
  padding: 0px;
  list-style: none;
}
input,
button {
  border: 0 none;
  border-radius: 0px;
  outline: none;
}
/* header */
.header {
  min-width: 1260px;
  height: 80px;
  background: rgba(255, 20, 47, 1);
  position: relative;
}
.headerLogo {
  width: 115px;
  height: 40px;
  position: absolute;
  top: 20px;
  left: 50px;
}
.headerLine {
  display: block;
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, 1);
  border-radius: 1px;
  position: absolute;
  top: 32px;
  left: 171px;
}
.header .headerTxt {
  width: 128px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  position: absolute;
  top: 29px;
  left: 178px;
}
/* openStep */
.openStep {
  width: 1180px;
  height: 150px;
  background: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 210px;
}
.openStep .circle {
  width: 51px;
  height: 51px;
  border-radius: 50%;
  background: rgb(255, 230, 233);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  /* opacity: 0.3; */
}

.openStep .circle1 {
  width: 43px;
  height: 43px;
  border-radius: 50%;
  font-size: 26px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  background: rgb(255, 176, 171);
  line-height: 37px;
  text-align: center;
  line-height: 43px;
}
.openStep .check_circle .circle1 {
  background: linear-gradient(
    90deg,
    rgba(255, 20, 47, 1) 0%,
    rgba(255, 72, 20, 1) 100%
  );
}
.openStep .circleSmall {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 4px;
  background: rgba(221, 221, 221, 1);
  margin: 20px -8px;
  margin-top: -12px;
}
.openStep .stepTxt {
  width: 52px;
  height: 18px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: rgba(153, 153, 153, 1);
  line-height: 18px;
  text-align: center;
}
.check_stepTxt {
  width: 52px;
  height: 18px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  color: rgba(255, 20, 47, 1);
}
.five span {
  margin-left: 14px;
}
/* content */
.content {
  width: 1180px;
  min-height: 325px;
  height: calc(100vh - 290px);
  background: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
  font-size: 50px;
  text-align: center;
  line-height: calc(100vh - 290px);
  position: relative;
}

.right-btn {
  position: absolute;
  bottom: 20px;
  left: 340px;
  margin: 0 auto;
  width: 500px;
  height: 40px;
  background: rgba(255, 20, 47, 1);
  border-radius: 4px;
  span {
    span {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFangSC;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      line-height: 16px;
    }
  }
}
.right-btn:hover {
  background: rgba(255, 20, 47, 1);
}
</style>
